import { memo, useState } from "react";
import { Popup } from "@/components/popups/Popup";
import { INITIAL_STEP, SUCCESS_STEP, CREATE_STEP } from "./constants";
import { CreateForm } from "./CreateForm";
import "./styles/CreateNichePopup.scss";
import { onCloseCreateNichePopup } from "@/components/popup-dispatcher/PopupDispatcher";

interface StepMap {
  [key: string]: {
    title: string | undefined;
    onBack?: () => void;
    render: () => React.ReactElement;
    btnProps: {
      variant?: number;
      title?: string;
      onClick?: () => void;
    };
  };
}

export const CreateNichePopup = memo(() => {
  const [step, setStep] = useState(INITIAL_STEP);

  const renderNicheInfo = () => (
    <div className="CreateNichePopup-NicheInfo">
      <p>Niches are public spaces where RedGIFs users connect around a shared theme.</p>
      <p>To get started, you'll need:</p>
      <ul>
        <li><strong>Avatar & banner</strong> - Give your Niche its own unique look.</li>
        <li><strong>Name & description</strong> - Let people know exactly what to expect.</li>
        <li><strong>Tag & preferences</strong> - Keep your Niche on theme and easy to browse.</li>
      </ul>
      <p>
        Our team will review your submission to make sure it follows
        our <a href="https://help.redgifs.com/hc/en-us/articles/39355219651473-Recommender-System-Guidelines" rel="noopener noreferrer" target="_blank">Guidelines</a> and
        is ready for the community to enjoy.
      </p>
      <p>Press <strong>Continue</strong> to set up your Niche.</p>
    </div>
  );

  const renderNicheSuccess = () => (
    <div className="CreateNichePopup-NicheSuccess">
      <p>Congratulations! Your niche has been submitted  to our community team for review.</p>
      <p>
        Due to the popularity of niches, the review process can take up to 48 hours,
        so please wait at least two days before following up on your submission.
      </p>
      <p>Thanks again for your interest in creating a new niche on RedGIFs!</p>
    </div>
  );

  const stepMap: StepMap = {
    [INITIAL_STEP]: {
      title: "Create a Niche",
      render: () => renderNicheInfo(),
      btnProps: {
        variant: 1,
        title: "Continue",
        onClick: () => setStep(CREATE_STEP),
      }
    },
    [CREATE_STEP]: {
      title: undefined,
      render: () => <CreateForm handleGoSuccess={() => setStep(SUCCESS_STEP)} />,
      btnProps: {},
      onBack: () => setStep(INITIAL_STEP)
    },
    [SUCCESS_STEP]: {
      title: "Success",
      render: () => renderNicheSuccess(),
      btnProps: {
        variant: 1,
        title: "Close",
        onClick: onCloseCreateNichePopup
      }
    }
  };

  const { title, render, btnProps, onBack } = stepMap[step];

  return (
    <Popup
      isOpen={true}
      title={title}
      onBack={onBack}
      onClose={onCloseCreateNichePopup}
      popupClass="CreateNichePopup"
      btnProps={btnProps}
      disableBackdropClose
    >
      {render()}
    </Popup>
  );
});
